import { NgModule } from '@angular/core';

import { BrokerCalendarComponent } from './broker-calendar.component';
import { SharedModule } from '../shared/shared.module';
import { MenuCalendarComponent } from './menu-calendar/menu-calendar.component';
import { CalendarViewComponent } from './calendar-view/calendar-view.component';
import { CalendarMarkModalComponent } from './calendar-mark-modal/calendar-mark-modal.component';
import { CalendarMarkComponent } from './calendar-mark/calendar-mark.component';
import { FilterCalendarComponent } from './filter-calendar/filter-calendar.component';

@NgModule({
  declarations: [
    BrokerCalendarComponent,
    MenuCalendarComponent,
    CalendarViewComponent,
    CalendarMarkModalComponent,
    CalendarMarkComponent,
    FilterCalendarComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    BrokerCalendarComponent,
    MenuCalendarComponent,
    CalendarViewComponent,
    CalendarMarkModalComponent,
    FilterCalendarComponent
  ]
})
export class BrokerCalendarModule { }
